import noxios from '@/utils/axios/noxios'

const notificationApi = {
  fetchNotifications: ({ partitionKey, params }: req.Notification) => {
    return noxios.get<res.Notifications>(`/${partitionKey}`, {
      params,
    })
  },
  fetchUnreadCount: ({ partitionKey }: req.NotificationPartitionKey) => {
    return noxios.get<res.UnreadCount>(`/${partitionKey}/unread-count`)
  },
  readNotification: ({ partitionKey, params }: req.ReadNotification) => {
    return noxios.put(`/${partitionKey}/read`, undefined, { params })
  },
  deleteCTA: ({ partitionKey, sortKey, action }: req.DeleteNotificationCTA) => {
    return noxios.delete(`/${partitionKey}/${sortKey}/cta/${action}`)
  },
}

export default notificationApi
